const resizer = function () {
    this.style.height = 'auto';
    this.style.height = `calc(${this.scrollHeight}px + 0.125rem)`;
};

// Textarea component
export default function () {
    let root;

    return {
        init() {
            root = this.$root;
            root.addEventListener('input', resizer);
            resizer.call(root);
        },

        destroy() {
            root.removeEventListener('input', resizer);
        },
    };
}
